import { FC } from 'react';
import { CardType, ProductCardComponentPropsTypes, ProductCardComponent } from '../Molecules';
import { PromotionCardPropsTypes } from './types/propsTypes';
import styles from './PromotionCard.module.scss';

export const PromotionCard = (Component: FC<ProductCardComponentPropsTypes>) => {
  const PromotionComp = (props: PromotionCardPropsTypes): JSX.Element => {
    const {
      brandName,
      productName,
      link,
      alt,
      productId,
      productSize,
      derivedAvailabilityStatus,
      productPrice,
      currency,
      productQuantity,
      strikethroughPrice,
      maxCount,
      disabled,
      productCount,
      onQuantityDecrease,
      onQuantityIncrease,
      showZeroAsFree = false,
    } = props;
    return (
      <>
        <div className={styles['cpw-promotion-drawer-card']}>
          <Component
            brandName={brandName}
            productName={productName}
            link={link}
            alt={alt}
            productId={''}
            productSize={productSize}
            derivedAvailabilityStatus={derivedAvailabilityStatus}
            productPrice={productPrice}
            currency={currency}
            productQuantity={productQuantity}
            cardType={CardType.PROMOTIONCARD}
            strikethroughPrice={strikethroughPrice}
            onQuantityIncrease={onQuantityIncrease}
            onQuantityDecrease={onQuantityDecrease}
            disabled={disabled}
            productCount={productCount}
            maxCount={maxCount}
            id={productId}
            showLinkForProductCard={false}
            showZeroAsFree={showZeroAsFree}
          />
        </div>
      </>
    );
  };
  return PromotionComp;
};

export default PromotionCard(ProductCardComponent);
export type { PromotionCardPropsTypes };
